import Seo from "@/components/Seo";
import { PageHeader, ServicesGrid, HowItWorks, CustomerJourneys, CtaBand } from "@/components/sections";

export default function Services() {
  return (
    <>
      <Seo
        title="Services — Bookkeeping, Accounting, Tax & Payroll"
        description="Explore Bonsai Financial's services: bookkeeping, accounting and financial reporting, tax services, payroll, and business and financial support for South African clients."
        path="/services"
      />
      <PageHeader
        eyebrow="Our Services"
        title="Practical accounting support, tailored to you."
        intro="Bonsai Financial combines five core service areas to match the requirements, size and complexity of each client. We do not make guarantees about SARS outcomes or tax savings — we provide reliable, professional support."
      />
      <ServicesGrid withHeading={false} />
      <CustomerJourneys />
      <HowItWorks />
      <CtaBand from="services-cta" />
    </>
  );
}
